import { userPermissionDTO } from '@higo/api';
import { useMemo } from 'react';
import { useAPIOAuth2AccessTokenQuery } from 'services/apiOAuth2AccessTokenService';

export const useUserPermissions = () => {
  const { data } = useAPIOAuth2AccessTokenQuery();
  const userPermissions = data?.accessTokenData.permissions[0];

  return useMemo(
    () =>
      userPermissions
        ? {
            agreementPermission:
              (userPermissions['AGREEMENT'] as userPermissionDTO) || false,
            attachmentsPermission:
              (userPermissions['ATTACHMENTS'] as userPermissionDTO) || false,
            commentsPermission:
              (userPermissions['COMMENTS'] as userPermissionDTO) || false,
            diagnosisPermission:
              (userPermissions['DIAGNOSIS'] as userPermissionDTO) || false,
            doctorPermission:
              (userPermissions['DOCTOR'] as userPermissionDTO) || false,
            doctorPortalAccessPermission:
              (userPermissions['DOCTOR_PORTAL_ACCESS'] as userPermissionDTO) ||
              false,
            examPermission:
              (userPermissions['EXAMINATION'] as userPermissionDTO) || false,
            examAssignmentPermission:
              (userPermissions[
                'EXAMINATION_ASSIGNMENT'
              ] as userPermissionDTO) || false,
            notesPermission:
              (userPermissions['NOTES'] as userPermissionDTO) || false,
            partnerPermission:
              (userPermissions['PARTNER'] as userPermissionDTO) || false,
            patientPermission:
              (userPermissions['PATIENT'] as userPermissionDTO) || false,
            shareExamPermission:
              (userPermissions['SHARE_EXAMINATION'] as userPermissionDTO) ||
              false,
            surveyPermission:
              (userPermissions['SURVEY'] as userPermissionDTO) || false,
            testPermission:
              (userPermissions['TEST'] as userPermissionDTO) || false,
            visitPermission:
              (userPermissions['VISIT'] as userPermissionDTO) || false,
          }
        : {
            agreementPermission: undefined,
            attachmentsPermission: undefined,
            commentsPermission: undefined,
            diagnosisPermission: undefined,
            doctorPermission: undefined,
            doctorPortalAccessPermission: undefined,
            examPermission: undefined,
            examAssignmentPermission: undefined,
            notesPermission: undefined,
            partnerPermission: undefined,
            patientPermission: undefined,
            shareExamPermission: undefined,
            surveyPermission: undefined,
            visitPermission: undefined,
          },
    [userPermissions],
  );
};
